import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Project } from './project';

/**
 * Backend-agnostic contract for the projects collection.
 * Implementations live alongside their backend (e.g. libs/api/projects/firebase),
 * and are bound to PROJECTS_COLLECTION at the app composition root.
 */
export interface ProjectsCollection {
  getProjects(): Observable<Project[]>;
  addProject(project: Project): Promise<unknown>;
  editProject(project: Project): Promise<void>;
  deleteProject(project: Project): Promise<void>;
}

export const PROJECTS_COLLECTION = new InjectionToken<ProjectsCollection>(
  'PROJECTS_COLLECTION',
);
